function replaceExtensionWithDzi(imageUrl) {
    const urlWithoutExtension = imageUrl.substring(0, imageUrl.lastIndexOf('.'));
    return `${urlWithoutExtension}.dzi`;
}

function correctImageUrl(filename) {
    return filename;
}

function correctImageUrlForDzi(filename) {
    return filename;
}

function getMainImage(record) {
    let image = "";

    let filename = "";
    if (record?.data?.record?.image) {
        if (Array.isArray(record?.data?.record?.image)) {
            if (record?.data?.record?.image.length > 0) {
                const imageWithLowestRank = record.data.record.image.reduce((prev, curr) => {
                    return parseInt(prev.rank) < parseInt(curr.rank) ? prev : curr;
                });
                filename = imageWithLowestRank.image;
            }
        } else {
            filename = record.data.record.image.image; // JH 22.11.2024 - index now includes image and rank in parent image tag
        }
    }

    return filename;
}

function getAdditionalImages(record) {
    //todo, klopt dit?
    //geen imagesMore tag?
    const images = Array.isArray(record?.data?.record?.image) ? record?.data?.record?.image : [record?.data?.record?.image];
    const sortedImages = images.filter(Boolean).sort((a, b) => parseInt(a.rank) - parseInt(b.rank));
    return (sortedImages);
}

function getImageParameters(showType, filename) {
    const correctedFilename = correctImageUrl(filename);
    let url = '';

    switch (showType) {
        case 'icon':
            url = generateImageUrl(correctedFilename, showType, { width: 240, height: 160, bg: 'ffffff' });
            return { url };
        case 'imagelist':
            url = generateImageUrl(correctedFilename, showType, { height: 100, bg: 'ffffff' });
            return { url };
        case 'imagebare':
            url = generateImageUrl(correctedFilename, showType, { });
            return { url };
            case 'iconscroll':
            url = generateImageUrl(correctedFilename, showType, { width: 180, bg: 'ffffff' });
            return { url };
        case 'list':
            url = generateImageUrl(correctedFilename, showType, { width: 220, bg: 'ffffff' });
            return { url };
        case 'mobilelist':
            url = generateImageUrl(correctedFilename, showType, { width: 240, height: 120, bg: 'ffffff' });
            return { url };
        case 'mobilerecord':
            url = generateImageUrl(correctedFilename, showType, { width: 640, bg: 'ffffff' });
            return { url };
        case 'filmstrip':
            url = generateImageUrl(correctedFilename, showType, { height: 100, bg: 'ffffff' });
            return { url };
        case 'pdf':
            url = generateImageUrl(correctedFilename, showType, { width: 440 });
            return { url };
        case 'dzi':
            url = replaceExtensionWithDzi(generateImageUrl(correctImageUrlForDzi(filename), showType, {}));
            return { url };
        default:
            url = generateImageUrl(correctedFilename, showType, { bg: 'ffffff'});
            return { url };
    }
}

function generateImageUrl(filename, showType, parameters) {
    if (showType === 'dzi') {
        return `${process.env.REACT_APP_IMAGE_BASE_URL}/${filename}`;
    }

    const queryParams = [];
    if (parameters.width) queryParams.push(`width=${parameters.width}`);
    if (parameters.height) queryParams.push(`height=${parameters.height}`);
    if (parameters.bg) queryParams.push(`bg=${parameters.bg}`);
    const queryString = queryParams.length > 0 ? `&${queryParams.join('&')}` : '';
    return `${process.env.REACT_APP_IMAGE_BASE_URL}${filename}${queryString}`; // mdlvw doesn't accept / as first char for filename
}

export function getImages(record) {
    const mainImage = getMainImage(record);
    const additionalImages = getAdditionalImages(record);

    const showTypes = ['icon', 'iconscroll', 'list', 'mobilelist', 'mobilerecord', 'filmstrip', 'pdf', 'dzi', 'imagelist', 'imagebare'];

    const result = {};

    showTypes.forEach(showType => {
        const mainImageParameters = mainImage ? getImageParameters(showType, mainImage) : null;

        const images = mainImageParameters ? [
            {
                url: mainImageParameters.url,
                rank: 'main',
            },
            ...additionalImages.map(image => {
                const additionalImageParameters = getImageParameters(showType, image.imagesmore);
                return {
                    url: additionalImageParameters.url,
                    rank: image.rank,
                };
            })
        ] : additionalImages.map(image => {
            const additionalImageParameters = getImageParameters(showType, image.imagesmore);
            return {
                url: additionalImageParameters.url,
                rank: image.rank,
            };
        });

        result[showType] = images.length > 0 ? images : [];
    });

    return result;
}
